import { render, staticRenderFns } from "./unpicked.vue?vue&type=template&id=61610804&scoped=true&"
import script from "./unpicked.vue?vue&type=script&lang=js&"
export * from "./unpicked.vue?vue&type=script&lang=js&"
import style0 from "./unpicked.vue?vue&type=style&index=0&id=61610804&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61610804",
  null
  
)

export default component.exports